export enum DisbursementTriggerActivationTypeEnum {
  Automatically = "Automatically",
  Manual = "Manual"
}
export const DisbursementTriggerActivationTypeLabel = new Map<DisbursementTriggerActivationTypeEnum, string>([
  [DisbursementTriggerActivationTypeEnum.Automatically, "Automático"],
  [DisbursementTriggerActivationTypeEnum.Manual, "Manul"],
]);



// WEBPACK FOOTER //
// ./src/services/Enum/DisbursementTriggerActivationTypeEnum.ts